/* eslint-disable */
export const getCurrentLocation = () => window.location.toString().replace(/#.*$/mg, '').match(/^.*?\/\/.*?(?=\/)/)[0];

const encodeLinkBeforeSave = (link) =>
{
  var domainList = `aero|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|ac|ad|ae|af|ag|ai|al|am|an|ao|aq|
  ar|as|at|au|aw|az|ba|bb|bd|be|bf|bg|bh|bi|bj|bm|bn|bo|br|bs|bt|bv|bw|by|bz|ca|cc|cd|cf|cg|ch|ci|ck|cl|cm|cn|co|cr|
  cu|cv|cx|cy|cz|de|dj|dk|dm|do|dz|ec|ee|eg|eh|er|es|et|eu|fi|fj|fk|fm|fo|fr|ga|gd|ge|gf|gg|gh|gi|gl|gm|gn|gp|gq|gr|
  gs|gt|gu|gw|gy|hk|hm|hn|hr|ht|hu|id|ie|il|im|in|io|iq|ir|is|it|je|jm|jo|jp|ke|kg|kh|ki|km|kn|kp|kr|kw|ky|kz|la|lb|
  lc|li|lk|lr|ls|lu|lv|ly|ma|mc|md|mg|mh|mk|ml|mm|mn|mo|mp|mq|mr|ms|mt|mu|mv|mw|mx|my|mz|na|nc|ne|nf|ng|ni|nl|no|np|
  nr|nu|nz|om|pa|pe|pf|pg|ph|pk|pl|pm|pn|pr|ps|pt|pw|py|qa|re|ro|ru|rw|sa|sb|sc|sd|se|sg|sh|si|sj|sk|sl|sm|sn|so|sr|
  st|sv|sy|sz|tc|td|tf|tg|th|tj|tk|tm|tn|to|tp|tr|tt|tv|tw|tz|ua|ug|uk|um|us|uy|uz|va|vc|ve|vg|vi|vn|vu|wf|ws|ye|yt|
  yu|za|zm|zr|zw`;

  var linkShemaPatternRegExp = '^(?:[A-Za-z0-9][A-Za-z0-9-]*\\.)+(?:' + (domainList.replace(/\|/g, '(?:\\/|\\:\\d|\\s*$)|') + '(?:\\/|\\:\\d|\\s*$)') + ')';
  var linkShemaPattern = new RegExp(linkShemaPatternRegExp, 'i');
  var mailShemaPattern = /^\s*[^\s\/\\\:\@]+\@([A-Za-z0-9][A-Za-z0-9-]*\.)+[A-Za-z0-9]{2,}\s*$/i;
  var relShemaPattern = /^(?:mailto:|[A-Za-z][A-Za-z0-9-_]*:\/\/|\/)(?:[0-9a-zA-Z\-_\=\+\~\!\@\$\&\*\(\)]|\s*$)/i;
  var linkMacrosPattern = new RegExp('{\\w+}', 'i');

  const gtrim = (string, charsToTrim) =>
  {
    charsToTrim = charsToTrim || '\\s';

    var regex = new RegExp('^[' + charsToTrim + ']*|[' + charsToTrim + ']*$', 'ig');

    return string.replace(regex, '');
  };

  var i,
    url,
    linkMatch,
    linkLeft = '',
    linkRight = '',
    anchor = '',
    anchorMatch,
    parts,
    paramParts;

  linkShemaPattern.lastIndex = 0;
  mailShemaPattern.lastIndex = 0;

  link = gtrim(link).replace(/^"(.*?)"$/, '$1');

  if (link === '')
  {
    return link;
  }

  if (linkMacrosPattern.test(link))
  {
    // do nothing
  }

  else if (linkShemaPattern.test(link))
  {
    link = 'http://' + link;
  }
  else if (mailShemaPattern.test(link))
  {
    link = 'mailto:' + link;
  }
  else if (link && link.substring(0,1) == '/')
  {
    // do nothing
  }
  else if (!relShemaPattern.test(link))
  {
    link = '/' + link;
  }

  url = link;

  anchorMatch = url.match(/^[\S\s]*\#(\S[\S\s]*)$/);

  if (anchorMatch && anchorMatch.length === 2)
  {
    anchor = '#' + encodeURI(decodeURIComponent(anchorMatch[1]));
    url = url.replace(/^([\S\s]*)\#\S[\S\s]*$/, '$1');
  }

  linkMatch = url.match(/^([\S\s]*?)\?([\S\s]*)$/);

  if (linkMatch)
  {
    if (linkMatch[1] != null)
    {
      linkLeft = encodeURI(decodeURI(linkMatch[1]));
    }

    if (linkMatch[2] != null)
    {
      linkRight = '?';

      parts = linkMatch[2].split('&');

      for (i = 0; i < parts.length; i++)
      {
        paramParts = parts[i].split('=');
        parts[i] = (paramParts[0] != null ? encodeURIComponent(decodeURIComponent(paramParts[0])) : '') + (paramParts[1] != null ? '=' + encodeURIComponent(decodeURIComponent(paramParts[1])) : '');
      }

      linkRight += parts.join('&');
      linkRight += anchor;
    }

    link = linkLeft + linkRight;
  }
  else
  {
    link = encodeURI(decodeURI(url));
  }

  return(link + anchor);
};


const processPageLink = (link) => link.replace(new RegExp(getCurrentLocation() + '([^A-Za-z0-9-.].*|$)', 'ig'), function (str, group1)
{
  return (group1 == null || group1 === '' ? '/' : group1);
});


const processInputLinkProp = (link) =>
{
  const replaceUrls =
    [
      {
        pattern: new RegExp(`^${getCurrentLocation()}([^A-Za-z0-9-.].*|$)`, 'i'),
        replace: (str, group1) => (group1 == null || group1 === '' ? '/' : group1)
      },
      {
        pattern: new RegExp('^(?:/?Content/Editor/(?:EditorContentBlank\\.aspx(?:\\?Theme[0-9.]*)?)?)(.*)', 'i'),
        replace: '$1'
      },
      {
        pattern: new RegExp('^(?:(?:/?Admin)?/?(?:Events|Members)/Email/(?:ComposeEmail\\.aspx)*)(.*)', 'i'),
        replace: '$1'
      },
      {
        pattern: new RegExp('^(/?)(?:Admin/)+(.+)', 'gi'),
        replace: '$1$2'
      },
      {
        pattern: new RegExp('^/?(?:Admin/)*Admin/?$', 'gi'),
        replace: '/'
      },
      {
        pattern: new RegExp('^Default\\.aspx(.+)', 'ig'),
        replace: '/Default.aspx$1'
      },
      {
        pattern: new RegExp('^/?Default\\.aspx$', 'ig'),
        replace: '/'
      },
      {
        pattern: new RegExp('^(?:\\.\\.\/\\.\\.\/)(.*)', 'gi'),
        replace: '/$1'
      },
      {
        pattern: new RegExp('^(?:\\.\\.\/)(.*)', 'gi'),
        replace: '/Content/$1'
      },
      {
        pattern: new RegExp('.*?(?:\\{|%7B)(.*?)(?:\\}|%7D).*', 'ig'),
        replace: '{$1}'
      }
    ];

  let result = link;

  for (let i = 0; i < replaceUrls.length; i++)
  {
    result = result.replace(replaceUrls[i].pattern, replaceUrls[i].replace);
  }

  return result;
};

export { processInputLinkProp, processPageLink, encodeLinkBeforeSave };